// ----------------------------------------------------------------------------
// Nombre del Programa : Usuarios
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para la vista y funciones de el listado de usuarios
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './Usuarios.scss';
import 'react-status-alert/dist/status-alert.css';
import { apiRequestToken } from '../../Utilidades/apiRequest';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Paginador } from '../../components/paginador/Paginador';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import Simplert from 'react-simplert';
import { UsuarioProps } from '../../interfaces/usuariosInterfaces';
import { RolProps } from '../../interfaces/rolesInterfaces';
import { getUsuarioi } from '../../Utilidades/session';

export const Usuarios = () => {
  const PAGE_SIZE = 8;
  const [pagActual, setPagActual] = useState<number>(0);
  const [RolSeleccionado, setRolSeleccionado] = useState('0');
  const [body, setBody] = useState<any>({});
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [cargado, setCargado] = useState<boolean>(false);
  const [usuarios, setUsuarios] = useState<UsuarioProps[]>([]);
  const [dateDesde, setDateDesde] = useState('');
  const [dateHasta, setDateHasta] = useState('');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [roles, setRoles] = useState<RolProps[]>([]);
  const [usuarioBorrar, setUsuarioBorrar] = useState<{
    idp: number;
    index: number;
  }>({
    idp: 0,
    index: 0,
  });

  useEffect(() => {
    cargarRoles();
  }, []);

  useEffect(() => {
    buscarUsuarios();
  }, [dateDesde, dateHasta, RolSeleccionado]);

  const cargarRoles = async () => {
    //setCargado(false);
    const response: any = await apiRequestToken({
      endpoint: 'roles',
      body,
      method: 'GET',
    }).catch(({ response }) => {
      const { data } = response;
      const noroles: RolProps[] = [];
      setRoles(noroles);
      //setCargado(true);
    });
    if (response.data && response.data.data) {
      setRoles(response.data.data);
      //setCargado(true);
    }
  };
  const usuariosMostrar = () =>
    usuarios.filter(
      (_, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const buscarUsuarios = async () => {
    setCargado(false);
    let endponam = '&name=' + (nombreUsuario !== '' ? nombreUsuario : '');
    let endpofini =
      dateDesde !== ''
        ? '&fechainicio=' + moment(dateDesde).format('YYYYMMDD')
        : '';
    let endpoffin =
      dateHasta !== ''
        ? '&fechafin=' + moment(dateHasta).add(1, 'd').format('YYYYMMDD')
        : '';
    let endporol = RolSeleccionado !== '0' ? '&rolid=' + RolSeleccionado : '';
    const response: any = await apiRequestToken({
      endpoint: 'usuarios?' + endponam + endpofini + endpoffin + endporol,
      body,
      method: 'GET',
    }).catch(({ response }) => {
      const { data } = response;
      const nousuarios: UsuarioProps[] = [];
      setUsuarios(nousuarios);
      setCargado(true);
    });
    if (response.data && response.data.data) {
      setUsuarios(response.data.data);
      setCargado(true);
    }
  };

  const borrarUsuario = async (idp: number, index: number) => {
    if (getUsuarioi() === String(idp)) {
      StatusAlertService.showError('No puedes borrar tu usuario');
      return;
    }
    let indexBorrar = pagActual * PAGE_SIZE + index;
    setUsuarioBorrar({ idp: idp, index: indexBorrar });
    setMostrarAlerta(true);
  };

  const confirmarBorrarUsuario = async () => {
    setMostrarAlerta(false);
    setCargado(false);
    const response: any = await apiRequestToken({
      endpoint: 'usuarios/' + usuarioBorrar.idp,
      body,
      method: 'DELETE',
    }).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      usuarios.splice(usuarioBorrar.index, 1);
      //setUsuarios(usuarios);
      setCargado(true);
      StatusAlertService.showSuccess('Borrado Exitosamente');
    }
  };

  const rolSeleccionadoUsuario = (event: any) => {
    setRolSeleccionado(event.target.value);
  };

  const enterUsuario = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
      buscarUsuarios();
    }
  };
  const handleChangeUsuario = (event: any) => {
    setNombreUsuario(event.target.value);
  };
  const actualizarRolUsuario = async (id: String, usuario_id: Number) => {
    if (getUsuarioi() === String(usuario_id)) {
      StatusAlertService.showError('No puedes actualziar el rol de tu usuario');
      return;
    }
    const usuariosseleccionados: UsuarioProps[] = usuarios.filter(
      (usuarios) => usuarios.usuario_id === usuario_id
    );
    usuariosseleccionados.forEach((usuario) => {
      let rol = roles.filter((roles) => roles.tiporol_id === Number(id))[0];
      //rol.tiporol_id = Number(id);
      //rol.nombreRol = usuario.tiporol_id.nombreRol;
      usuario.tiporol_id = rol;
    });

    const response: any = await apiRequestToken({
      endpoint: 'usuarios/',
      body: usuariosseleccionados,
      method: 'POST',
    }).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      StatusAlertService.showSuccess('Actualizado Correctamente');
    }
  };

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="¿Desea Eliminarlo?"
        message=""
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarUsuario()}
        onClose={() => setMostrarAlerta(false)}
      />
      <div className="m-5">
        <Row>
          <Col className="heading-1">Usuarios</Col>
        </Row>
        <div className="d-flex flex-row-reverse bd-highlight mb-3">
          <Link to={'/usuarios/agregar-usuario'}>
            <Button variant="primary" className="float-end">
              Agregar Usuarios
            </Button>
          </Link>
        </div>
        <Row className="mb-3">
          <Col sm={5}>
            <label></label>
            <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="Buscar por nombre"
                aria-label="Search"
                value={nombreUsuario}
                onKeyPress={enterUsuario}
                onChange={handleChangeUsuario}
                className="colorgray2"
              />
              <InputGroup.Text
                className="material-icons cursospointer"
                onClick={() => buscarUsuarios()}
              >
                search
              </InputGroup.Text>
            </Form>
          </Col>
          <Col sm={3}>
            <label></label>
            <Form.Select
              className="colorgray2"
              value={RolSeleccionado}
              onChange={rolSeleccionadoUsuario}
            >
              <option value="0">Rol</option>
              {roles.length > 0 ? (
                roles.map((rol, index) => (
                  <option key={rol.tiporol_id} value={rol.tiporol_id}>
                    {rol.nombreRol}
                  </option>
                ))
              ) : (
                <option value="0"></option>
              )}
            </Form.Select>
          </Col>
          <Col sm={2}>
            <label>Desde</label>
            <Form.Control
              type="date"
              name="datepicd"
              placeholder="Desde"
              className="colorgray2"
              value={dateDesde}
              onChange={(e) => setDateDesde(e.target.value)}
            />
          </Col>
          <Col sm={2}>
            <label>Hasta</label>
            <Form.Control
              type="date"
              name="datepich"
              placeholder="Hasta"
              className="colorgray2"
              value={dateHasta}
              onChange={(e) => setDateHasta(e.target.value)}
            />
          </Col>
        </Row>
        <Table responsive>
          <thead className="colorgray2">
            <tr>
              <th>Nombre</th>
              <th>Rol</th>
              <th>Fecha de alta</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.length > 0 ? (
              usuariosMostrar().map((usuario, index) => (
                <tr key={usuario.usuario_id} className="colorgray2">
                  <td
                    className={
                      index === 0 ? '' : index === usuarios.length - 1 ? '' : ''
                    }
                  >
                    {usuario.nombre}
                  </td>
                  <td>
                    <Form.Select
                      className="colorgray2 dropdowntabla"
                      value={usuario.tiporol_id.tiporol_id}
                      onChange={(e) =>
                        actualizarRolUsuario(e.target.value, usuario.usuario_id)
                      }
                    >
                      {roles.length > 0 ? (
                        roles.map((rol, index) => (
                          <option
                            key={rol.tiporol_id}
                            value={rol.tiporol_id}
                          >
                            {rol.nombreRol}
                          </option>
                        ))
                      ) : (
                        <option value="0"></option>
                      )}
                    </Form.Select>
                  </td>
                  <td>{moment(usuario.fecInserta).format('DD/MM/YYYY')}</td>
                  <td
                    className={
                      index === 0 ? '' : index === usuarios.length - 1 ? '' : ''
                    }
                    width="100"
                  >
                    <Button
                      variant="secondary"
                      onClick={() => borrarUsuario(usuario.usuario_id, index)}
                    >
                      <div className="material-icons">delete</div>
                    </Button>
                  </td>
                </tr>
              ))
            ) : cargado ? (
              <tr className="colorgray2">
                <td className="nodatos    " colSpan={4}>
                  No Existen Datos
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        <Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={usuarios.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
        </Row>
      </div>
    </>
  );
};
